import { axiosServices } from "./axiosServices";
import { isEmptyDash } from "../constant";
import { functions } from "lodash";
export const vendorServices = { getVendorEvaluationListing, createBulkProject, departHodMapping, getAssignSteps, getDeparHodListing, getVendorEvaluListing, submitVendorRating, submitVendorReallocate, getVendorEvaluationFilterlist, DownloadVendorExcelReport };

function getVendorEvaluationListing(param) {
    return axiosServices.getAxios(`/v1/internal/evaluation-events${param}`).then((res) => {
        return res;
    });
}

function createBulkProject(bodyData) {
    return axiosServices
        .postAxios("/v1/internal/evaluation-events", bodyData)
        .then((res) => {
            return res;
        });
}
function departHodMapping(bodyData) {
    return axiosServices
        .postAxios("/v1/internal/department-hod-mapping", bodyData)
        .then((res) => {
            return res;
        });
}


function getAssignSteps(param) {
    let data = isEmptyDash(param) ? "" : param;
    return axiosServices.getAxios(`/v1/internal/steps/assignees${data}`).then((res) => {
        // console.log(res);
        return res;
    });
}

function getDeparHodListing(param) {
    return axiosServices.getAxios(`/v1/internal/department-hod-mapping`).then((res) => {
        return res;
    });
}
function getVendorEvaluListing(id, param) {
    return axiosServices.getAxios(`/v1/internal/evaluation-events/${id}/${param}`).then((res) => {
        return res;
    });
}


function submitVendorRating(bodyData) {
    return axiosServices
        .postAxios("/v1/internal/vendor-evaluations/evaluate", bodyData)
        .then((res) => {
            return res;
        });
}

function submitVendorReallocate(bodyData) {
    return axiosServices
        .postAxios("/v1/internal/vendor-evaluations/reallocate", bodyData)
        .then((res) => {
            return res;
        });
}

function getVendorEvaluationFilterlist(id) {
    return axiosServices.getAxios(`/v1/internal/evaluation-events/${id}/filters`).then((res) => {
        return res;
    });
}

function DownloadVendorExcelReport(id) {
    return axiosServices.postAxios(`/v1/internal/evaluation-events/${id}/download-sheet`).then((res) => {
        return res;
    });
}
